import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import CopyToClipboard from 'react-copy-to-clipboard';
import { createStyles, WithStyles, withStyles } from '@material-ui/core/styles';

const styles = () =>
  createStyles({
    copyButton: {
      height: 'fit-content',
    },
  });

interface CopyButtonProps extends WithStyles<typeof styles> {
  textToCopy: string;
  onSelection?: () => void;
}

const CopyButton: React.FC<CopyButtonProps> = ({ textToCopy, onSelection, classes }) => (
  <IconButton
    data-lh-id="patient-form-insurance-answers-copy-button"
    onClick={onSelection}
    className={classes.copyButton}
  >
    <CopyToClipboard text={textToCopy}>
      <FileCopyIcon color="primary" fontSize="small" />
    </CopyToClipboard>
  </IconButton>
);

export default withStyles(styles)(CopyButton);
